module.exports = __webpack_public_path__ + "img/tertiary_11x2_z16.52d0d6fc.svg";